import { getOwner } from '@ember/application';
import type Owner from '@ember/owner';
import type Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { type Registry as Services } from '@ember/service';

const SPOT_ROUTE_FRAGMENT = '.properties.spot-';

export function resetSpotRangeOnExit(
  route: Route,
  isExiting: boolean,
  transition: Transition,
): void {
  if (!isExiting) {
    return;
  }

  const goingToSpotRoute = (transition?.to?.name ?? '').includes(
    SPOT_ROUTE_FRAGMENT,
  );

  if (goingToSpotRoute) {
    return;
  }

  const calendarManager = (getOwner(route) as Owner).lookup(
    'service:calendar/manager',
  ) as Services['calendar/manager'];

  calendarManager.interaction.resetSpotRangeOperation();
}
